<form [formGroup]="form">
  <div
    class="working-times-container"
    yp-e2e-id="time-interval-dropdown-control"
  >
    <div class="working-times-label d-flex align-items-center">
      {{ fromLabel }}
    </div>
    <div
      class="drop-down-container"
      [ngClass]="'z-index-' + overlayListZIndex"
      yp-e2e-id="time-interval-dropdown-from"
    >
      <app-dropdown-list
        [data]="timesFromListData"
        [formControl]="form.controls[fromControlKey]"
        class="fit-content"
      ></app-dropdown-list>
    </div>
    <div class="working-times-label d-flex align-items-center">
      {{ toLabel }}
    </div>
    <div
      class="drop-down-container"
      [ngClass]="'z-index-' + zIndex"
      yp-e2e-id="time-interval-dropdown-to"
    >
      <app-dropdown-list
        [data]="timesToListData"
        [formControl]="form.controls[toControlKey]"
        class="fit-content"
      ></app-dropdown-list>
    </div>
  </div>
</form>
